var map = {
	"./boat/boat.png": "89f3",
	"./boat/waves_back.png": "7266",
	"./boat/waves_top.png": "abfb",
	"./checkbox-error.png": "5d2e",
	"./checkbox-off.png": "b7c0",
	"./checkbox-on.png": "f6ca",
	"./help.png": "3a63",
	"./path.png": "46c8",
	"./pin-active.png": "074f",
	"./pin.png": "56a2",
	"./radio-error.png": "84fb",
	"./radio-off.png": "9cde",
	"./radio-on.png": "8a23",
	"./test.png": "1552",
	"./treatment-pack-1.png": "dbf7",
	"./treatment-pack-2.png": "baf0",
	"./video.png": "01f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";